/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum MaterialType {
  None = 'None',
  Primary = 'Primary',
  Secondary = 'Secondary',
  Trace = 'Trace'
}
